import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgWizardService } from "ng-wizard";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-list-apptakeover',
  templateUrl: './list-apptakeover.component.html',
  styleUrls: ['./list-apptakeover.component.scss']
})
export class ListApptakeoverComponent implements OnInit {

  apptakeoverLists:any = []
  formGroup:any
  submitted: boolean = false;
  page: any = 5;
  addOrEditAppTakeover: string = 'add'
  getPaginationCount:any;

  search = "";
  startDate: any = "";
  endDate: any = "";

  constructor(
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public router: Router,
    private toast: ToastClientService
  ) { }

  ngOnInit() {
    this.getAppTakeoverList();
  }


  get f() {
    return this.formGroup.controls;
  }


  getAppTakeoverList() {
    this.apiService.getHeaders(this.apiConfig.ConfigurationList + `?page=1&limit=${this.page}&search=${this.search}&start_date=${this.startDate}&end_date=${this.endDate}`)
      .subscribe((res: any) => {
        this.apptakeoverLists = res.body.data.data;
        console.log(this.apptakeoverLists)
        // this.getPaginationCount = res.body.data.pagination.totalCount

      })
  }

      
    
  addConfig(addOrEdit:any,data?:any) {
    let configId
    this.addOrEditAppTakeover = addOrEdit
    let appTakeoverStepFlags = {
      createConfigFlag : addOrEdit == 'add' ? true : true,
      whitelistFlag : addOrEdit == 'add' ? false : true
    }
    let configDetail = {
      id : addOrEdit == 'edit' ? data.id : "",
      is_edit : addOrEdit == 'edit' ? true : false ,
      start_date : addOrEdit == 'edit' ? data.start_date : "",
      end_date : addOrEdit == 'edit' ? data.end_date : "",
      whitelisting_type: addOrEdit == 'edit'? data.whitelisting_type:'',
      // role_type : addOrEdit == 'edit'? data.role_type:'',
      // zone_id : addOrEdit == "edit" ? data.zone_id:'',
      region_id : addOrEdit == "edit" ? data.region_id:'',
      state_id : addOrEdit == "edit" ? data.state_id:'',
      city_id : addOrEdit == "edit" ? data.city_id:'',  
    }
    addOrEdit === 'edit' ? configId = data.id : configId =  0
    localStorage.setItem("appTakeoverStepFlags", JSON.stringify(appTakeoverStepFlags))
    localStorage.setItem("appTakeoverList", JSON.stringify(configDetail))
    this.router.navigate(["/hubAdmin/apptakeover-setup/" + configId]);
  }


  toggleStatus(data){
    let payload = {
      config_id : data.id,
      status : data.status == 0 ? 1 : 0
    }
    this.apiService.post(this.apiConfig.updateStatus , payload).subscribe((res:any)=>{
      console.log(res);
      this.toast.Success(res.body.data.message) 
      this.getAppTakeoverList()
    })
  }


  reset(){
    this.startDate = ''
    this.endDate = ''
    this.search = ''
    this.getAppTakeoverList()
  }

}
